export default __webpack_public_path__ + "static/media/Aura-Egg__22.07355b47.png";